export const populars = [
    { title: "circle01", intro: "Where music lovers gather!", number: "7 / 7" },
    { title: "circle02", intro: "Let's read and discuss books!", number: "2 / 8" },
    { title: "circle03", intro: "Your favorite food, one bite at a time", number: "3 / 10" },
    { title: "circle04", intro: "Casual hangouts, deep conversations", number: "5 / 5" },
]